import React, { useEffect, useState } from 'react'
import styles from "../assets/css/UserList.module.css";
import { Loader } from '../../components/Loader';
import {getCustomerOrder} from '../../services';
function RequestedOrder() {
    const [loader, setLoader] = useState(true);
    const [customerOrders, setCustomerOrders] = useState([]);

    useEffect(() => {
        const fetchCustomerOrders = async () => {
            try {
                const orders = await getCustomerOrder();
               
                setCustomerOrders(orders);
            } catch (error) {
                console.error("Error fetching customer orders:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchCustomerOrders();
    }, []);

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>REQUESTED ORDERS</h1>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span >
            USER NAME
          </span>
          <span >
            CONTACT NO 
          </span>
          <span >
            EMAIL 
          </span>
          <span >
            ADDRESS 
          </span>
          <span >
            PRODUCT/SELLER DETAILS 
          </span>
          <span >
           PRODUCT PRICE
          </span>
          <span>SERVICES</span>
        </div>

        {customerOrders?.map((data, index) => {
          return (
            <div className={styles.itemData} key={index}>
             
              <span>{data?.name}</span>
              <span>{data?.contact_no}</span>
              <span>{data?.user_email}</span>
              <span>{data?.address}</span>
              <span>{data?.others.productName}, {data?.others.sellerName}</span>
              <span>
                ₹ {data?.order_price}
              </span>
              <span>
                 {data?.services}
              </span>

             
            </div>
          );
        })}
      </div>
    

      {loader && <Loader />}
    </section>
  )
}

export default RequestedOrder
